import { InteractionRequiredAuthError } from "@azure/msal-browser";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import logo from '../../assets/logo.png';
import { AccessToken } from "../../config/AccessToken";
import { ConversionsChart } from "./ConversionsChart";

export const Devices = () => {

  const SERVER_URL = process.env.REACT_APP_SERVER_URL;
  const [error, setError] = useState('');
  const [instance, accessTokenRequest] = AccessToken();
  let languageId = localStorage.getItem('languageId');

  //const [devicesInfo, setDevicesInfo] = useState(null);
  const [counterActiveDevices, setCounterActiveDevices] = useState(null);
  const [counterInactiveDevices, setCounterInactiveDevices] = useState(null);

  const getDeviceList = async (flag?: boolean) => {

    const commonOperations = (accessToken: any) => {
      const headers = { 'Authorization': `Bearer ${accessToken}`, 'Language': languageId };
      axios.get(`${SERVER_URL}/device/list`, {headers})
        .then((res) => {
          const data: any = res?.data?.data
          let activeDevices: any = 0
          let inactiveDevices: any = 0

          data.forEach((device: any) => {
            if(device.isEnabled) {
              activeDevices++
            }else{
              inactiveDevices++
            }
          });
          setCounterActiveDevices(activeDevices);
          setCounterInactiveDevices(inactiveDevices);

        }).catch((data) => {
          setError(data?.message);
        });
    }

    if (sessionStorage.getItem('accessToken') != null) {
      let accessToken = sessionStorage.getItem('accessToken');
      commonOperations(accessToken);
    } else {
      await instance.initialize();
      await instance.setActiveAccount(accessTokenRequest.account);
      await instance.acquireTokenSilent(accessTokenRequest).then((accessTokenResponse: any) => {
        // Acquire token silent success
        let accessToken = accessTokenResponse.accessToken;
        commonOperations(accessToken);
      })
        .catch((error: any) => {
          if (error instanceof InteractionRequiredAuthError) {
            instance.acquireTokenRedirect(accessTokenRequest);
          }
          console.log(error);
        });
    }
  }

  useEffect(() => {
    getDeviceList()
  }, [])

  return (
    <div style={{ zoom: '70%' }}>
      <ConversionsChart firstValue={counterActiveDevices ?? 0} secondValue={counterInactiveDevices ?? 0} />     
      {/*{ counterActiveDevices != null && counterInactiveDevices != null &&
      }*/}
    </div>
  );
};